import "./UserManagement.scss";
import { ReactNode, useEffect, useRef, useState } from "react";
import { ReactComponent as AddClinicIcon } from "../../assets/svg/AddClinic.svg";
import { ReactComponent as EditUser } from "../../assets/svg/edit.svg";
import { ReactComponent as Reset } from "../../assets/svg/reset.svg";
import Grid from "../shared/Grid/Grid";
import Button from "@mui/material/Button";
import ConfirmationDialog from "../shared/ConfirmationDialog/ConfirmationDialog";
import Slider from "../shared/Widget/Slider/Slider";
import AddClinic from "./AddClinic/AddClinic";
import { userManagement_LABELS } from "../../constants/labels/UserManagement";
import { GridColumnDefs } from "../../models/Grid/gridColumnDefs";
import { UserService } from "../../services/UserService";
import { Roles } from "../../constants/data/Roles";
import { FORM_TYPE } from "../../constants/enums/formTypes";
import { FormikProps } from "formik";
import ClinicHandler from "./ClinicHandler/ClinicHandler";
import { useAuth } from "../../context/AuthProvider";

function UserManagement() {
  const [openConfirmation, setOpenConfirmation] = useState<number | null>(null);
  const [singleSuperAdmin, setSingleSuperAdmin] = useState<number | null>(null);
  const [singleSuperAdminMessage, setSingleSuperAdminMessage] =
    useState<string>();
  const [filterCriteria, setFilterCriteria] = useState<any>({
    pageNumber: 1,
    pageSize: 20,
  });
  const [rowData, setRowData] = useState<any>([]);
  const [rowcount, setRowCount] = useState(0);
  const [searchString, setSearchString] = useState<string>("");
  const [auditSearchString, setAuditSearchString] = useState<string>("");
  const [resetApplicationId, setResetApplicationId] = useState<number | null>(
    null
  );
  const [openAudit, setOpenAudit] = useState<string>();
  const [open, setOpen] = useState(false);
  const [openSlider, setOpenSlider] = useState<boolean>(false);
  const [formType, setFormType] = useState<string>("");
  const [initialFormValue, setInitialFormValue] = useState<any>({});
  const [applicationUserId, setApplicationUserId] = useState<string>("");
  const [openConfirmationPopUp, setOpenConfirmationPopUp] =
    useState<boolean>(false);
  const userFormRef = useRef<FormikProps<any>>(null);
  const clinicFormRef = useRef<FormikProps<any>>(null);
  const auth = useAuth();
  useEffect(() => {
    setRowData([
      {
        applicationUserId: 26,
        firstName: "Amrutha Notifications",
        lastName: "tesing",
        emailAddress: "amrutha.ittamsetty+SUN@techigai.io",
        contactNumber: "987564",
        role: "SUPPORT USER",
        roleId: "E8683AD7-1ED6-4433-B773-9B5298321040",
        userId: "7ddf720d-5935-4883-aa06-7a78a3e0e663",
        isActive: true,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
      {
        applicationUserId: 25,
        firstName: "AmruthaIttamsetty",
        lastName: "SupportUser",
        emailAddress: "amrutha.ittamsetty+supportuser01@techigai.io",
        contactNumber: "9879879874",
        role: "SUPPORT USER",
        roleId: "E8683AD7-1ED6-4433-B773-9B5298321040",
        userId: "8d88365c-8481-4717-82ce-853d7a4828c0",
        isActive: false,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
      {
        applicationUserId: 24,
        firstName: "Amrutha",
        lastName: "SupportUser",
        emailAddress: "amrutha.ittamsetty+Support13@techigai.io",
        contactNumber: "1231231231",
        role: "SUPPORT USER",
        roleId: "E8683AD7-1ED6-4433-B773-9B5298321040",
        userId: "4386a944-1264-4cae-a2ff-3ced16aa640d",
        isActive: false,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
      {
        applicationUserId: 23,
        firstName: "Amrutha",
        lastName: "SupportUser",
        emailAddress: "Amrutha.ittamsetty+Support12@techigai.io",
        contactNumber: "12345612345",
        role: "SUPPORT USER",
        roleId: "E8683AD7-1ED6-4433-B773-9B5298321040",
        userId: "f3378399-08d4-45c7-baf6-0f53c1651e69",
        isActive: false,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
      {
        applicationUserId: 22,
        firstName: "Dimple",
        lastName: "Test User",
        emailAddress: "dimple.tangeti@techigai.io",
        contactNumber: "1234567890",
        role: "SUPPORT USER",
        roleId: "E8683AD7-1ED6-4433-B773-9B5298321040",
        userId: "d6ee3360-7759-4d6e-a08b-b909e217f170",
        isActive: false,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
      {
        applicationUserId: 21,
        firstName: "Support",
        lastName: "User two testing",
        emailAddress: "amrutha.ittamsetty+su2@techigai.io",
        contactNumber: "12589646658",
        role: "SUPER USER",
        roleId: "DA487F01-3D70-439B-ADFF-D9B5CAB46D5A",
        userId: "f905ea52-a422-43d3-b93e-8e37b2ec448b",
        isActive: false,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
      {
        applicationUserId: 20,
        firstName: "Amrutha",
        lastName: "testingtest",
        emailAddress: "amrutha.ittamsettytest@techigai.io",
        contactNumber: "6546549876546546798787987987",
        role: "SUPPORT USER",
        roleId: "E8683AD7-1ED6-4433-B773-9B5298321040",
        userId: "7b56ecc9-9e7e-4c94-b12a-372aae0b7d87",
        isActive: true,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
      {
        applicationUserId: 19,
        firstName: "Lorem ipsum dolor sit amet consect eljhtyutyttyty",
        lastName: "Lorem ipsum dolor sit amet consectetureljhtyutyttyty",
        emailAddress: "amrutha.ittamsetty+k@techigai.io",
        contactNumber: "9865654654654646546546546546",
        role: "SUPPORT USER",
        roleId: "E8683AD7-1ED6-4433-B773-9B5298321040",
        userId: "371a6c23-31d7-4c0a-abdb-02687f6d3783",
        isActive: true,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
      {
        applicationUserId: 18,
        firstName: "Amrutha",
        lastName: "testing",
        emailAddress: "amrutha.ittamsetty+testing@techigai.io",
        contactNumber: "9876987654",
        role: "SUPPORT USER",
        roleId: "E8683AD7-1ED6-4433-B773-9B5298321040",
        userId: "7400a08e-db78-4450-9845-890f8eebd2e7",
        isActive: true,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
      {
        applicationUserId: 17,
        firstName: "YuvaReddy",
        lastName: "SupportUser",
        emailAddress: "yuvasekhar.chennareddy+s1@techigai.io",
        contactNumber: "9573188898",
        role: "SUPPORT USER",
        roleId: "E8683AD7-1ED6-4433-B773-9B5298321040",
        userId: "78872dc1-fb2a-4bee-aeef-7d9fe355a598",
        isActive: true,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
      {
        applicationUserId: 16,
        firstName: "YuvaReddy",
        lastName: "SupportUser",
        emailAddress: "yuvasekhar.chennareddy+support@techigai.io",
        contactNumber: "9573135888",
        role: "SUPPORT USER",
        roleId: "E8683AD7-1ED6-4433-B773-9B5298321040",
        userId: "8d97f106-8575-42cb-9898-599b8c895313",
        isActive: true,
        clinicName: "clinic 1",
        clinicId: 1,
        clinicAddress: "Texas",
        isClinicActive: true,
      },
    ]);
    setRowCount(50);
  }, []);

  const handleToggle = (id: number) => {
    setOpenConfirmation(id);
  };

  const handleConfirmToggle = (data: any) => {
    const requestContent: any = {
      applicationUserId: data.applicationUserId,
    };
    if (
      data.role.toUpperCase() === userManagement_LABELS.superAdmin.toUpperCase()
    ) {
      requestContent.roleName = userManagement_LABELS.superAdmin;
    }
    setOpenConfirmation(null);
  };

  const handleCancelToggle = () => {
    setOpenConfirmation(null);
  };

  const toggleStatus = (value: any) => {
    return <></>;
  };
  const UserActions = (props: any) => {
    return (
      <span
        className={`user-edit ${
          auth?.authClaims?.role?.toLowerCase() === Roles.generalPractitioner &&
          "m-4"
        }`}
      >
        <EditUser
          onClick={() => {
            if (
              props?.data?.role?.toLowerCase() === Roles.supportUser &&
              auth?.authClaims?.role?.toLowerCase() ===
                Roles.generalPractitioner
            )
              return;
            if (
              props?.data?.role?.issupportUser?.toLowerCase() ===
                Roles.supportUser &&
              auth?.authClaims?.role?.toLowerCase() ===
                Roles.generalPractitioner
            )
              return;
            setFormType("Edit");
            setInitialFormValue(props.data);
            setOpenSlider(true);
          }}
          title="Edit"
          className={`cursor-pointer ${
            ((props?.data?.role?.toLowerCase() === Roles.supportUser &&
              auth?.authClaims?.role?.toLowerCase() ===
                Roles.generalPractitioner) ||
              (props?.data?.role?.issupportUser?.toLowerCase() ===
                Roles.supportUser &&
                auth?.authClaims?.role?.toLowerCase() ===
                  Roles.generalPractitioner)) &&
            "pe-none"
          } ${
            props?.data?.role?.toLowerCase() === Roles.supportUser &&
            auth?.authClaims?.role?.toLowerCase() === Roles.generalPractitioner
              ? "action-disabled "
              : " "
          }`}
        />
        {auth?.authClaims?.role?.toLowerCase() === Roles.supportUser && (
          <>
            <Reset
              onClick={() => {
                if (props.data.isActive)
                  setResetApplicationId(props.data.applicationUserId);
              }}
              className={
                "ms-3 cursor-pointer " +
                (!props.data.isActive ? "disable-reset-Password" : "")
              }
              title={props.data.isActive ? "Reset Password" : ""}
            />
            {/* <ConfirmationDialog
              open={resetApplicationId === props.data.applicationUserId}
              message={`Reset Password link will be sent to ${props.data.emailAddress}`}
              onConfirm={() => {
                let resetPasswordRequest = {
                  Email: props.data.emailAddress,
                };

                setResetApplicationId(null);
              }}
              onCancel={() => setResetApplicationId(null)}
            /> */}
          </>
        )}
      </span>
    );
  };
  const ClinicContent = (props: any) => {
    return (
      <div>
        <div
          className="name-wrapper cursor-pointer text-overflow-ellipse"
          onClick={() => {
            if (props?.data?.clinicId)
              // setclinicDetails(props?.data?.clinicId);
              setApplicationUserId(props?.data?.applicationUserId);
          }}
          title={props?.data?.clinicName}
        >
          {props?.data?.clinicName}
        </div>
        <Slider
          isOpen={applicationUserId === props?.data?.applicationUserId}
          onClose={() => {
            if (clinicFormRef.current?.dirty) setOpenConfirmationPopUp(true);
            else {
              setApplicationUserId("");
              // setUsersData(filterCriteria);
            }
          }}
          title={"Clinic Details"}
        >
          <ClinicHandler
            clinicDetails={props.data}
            onClose={() => {
              setApplicationUserId("");
            }}
            formRef={clinicFormRef}
            openSlider={() => {
              setOpenSlider(true);
              // setclinicDetailsFromGrid(props.data);
              // if (setIsOpenedFromclinic != undefined)
              //   setIsOpenedFromclinic(true);
            }}
          />
        </Slider>
      </div>
    );
  };

  const columnDefs: GridColumnDefs[] = [
    {
      headerName: userManagement_LABELS.firstName,
      field: "firstName",
    },
    {
      headerName: userManagement_LABELS.lastName,
      field: "lastName",
    },
    {
      headerName: userManagement_LABELS.emailAddress,
      field: "emailAddress",
    },
    {
      headerName: userManagement_LABELS.contactNumber,
      field: "contactNumber",
    },
    {
      headerName: userManagement_LABELS.clinic,
      field: "clinicName",
      sortable: true,
      cellRenderer: ClinicContent,
    },
    {
      headerName: userManagement_LABELS.address,
      field: "address",
      sortable: true,
      cellRenderer: toggleStatus,
    },
    {
      field: userManagement_LABELS.actions,
      headerName: "Actions",
      cellRenderer: UserActions,
      sortable: false,
    },
  ];
  const onPageChange = (value: any) => {
    setFilterCriteria({
      ...filterCriteria,
      pageNumber: value,
    });
  };
  const onPageSizeChange = (value: any) => {
    setFilterCriteria({
      ...filterCriteria,
      pageNumber: 1,
      pageSize: value,
    });
  };
  const searchResults = (value: any) => {
    setSearchString(value);
    setFilterCriteria({
      ...filterCriteria,
      searchString: value?.trim().length > 0 ? value.trim() : null,
    });
  };
  const sordOrder = (columnName: string, order: string) => {
    if (order === "asc" || order === "desc") {
      setFilterCriteria({
        ...filterCriteria,
        sortByColumnName: columnName,
        sortOrder: order,
      });
    } else {
      setFilterCriteria({
        ...filterCriteria,
        sortByColumnName: null,
        sortOrder: null,
      });
    }
  };

  return (
    <div className="user-management-wrapper">
      {
        <Grid
          columnDefs={columnDefs}
          rowData={rowData}
          serverSidePagination
          rowCount={rowcount}
          serverSideSorting
          showPagination
          showFilterIcon
          pageSizeList={[10, 20, 50, 100]}
          pageSize={20}
          masterDetail
          isSearch={searchString?.length > 0}
          canSearch
          setSearchQuery={(values: string) => {
            searchResults(values);
          }}
          sortBy={(columnName, order) => {
            sordOrder(columnName, order);
          }}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
          searchFieldName=""
          headerContent={userManagement_LABELS.userManagement}
          actionButtons={[
            <>
              <Button
                variant="contained"
                startIcon={<AddClinicIcon />}
                onClick={() => {
                  setFormType("Add");
                  setInitialFormValue({
                    roleId: "",
                    logo: "ribbon.png",
                  });
                  setOpenSlider(true);
                }}
              >
                {userManagement_LABELS.addClinic}
              </Button>
            </>,
          ]}
          showTotalRowCount
          uniqueIdentifierFieldName={"id"}
        ></Grid>
      }
      <Slider
        isOpen={openSlider}
        onClose={() => {
          if (userFormRef?.current?.dirty) setOpenConfirmationPopUp(true);
          else {
            setOpenSlider(false);
          }
        }}
        title={`${formType} Clinic`}
      >
        <AddClinic
          formType={FORM_TYPE.ADD}
          formInitialValues={initialFormValue}
          onClose={() => {
            setOpenSlider(!openSlider);
          }}
        />
      </Slider>
    </div>
  );
}

export default UserManagement;
